import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class TonalityService {
	private db;
	tonalities: FirebaseListObservable<Tonality[]>;

	constructor(private firebaseService: FirebaseService) {
		this.db = firebaseService.db;
		this.loadTonalities();
	}

	/**
	 * Load initial data
	 */
	loadTonalities() {
		window.dispatchEvent(new Event('loading'));
		this.tonalities = this.db.list('/tonalities') as FirebaseListObservable<Tonality[]>
		this.tonalities.subscribe(data => {
			this.triggerDataChange();
		});

		return this.tonalities;
	}

	triggerDataChange() {
		window.dispatchEvent(new Event('data-loaded'));
	}

	/**
	 * Get All Tonalities
	 */
	getTonalities() {
		return this.tonalities;
	}

	/**
	 * Get Tonality by ID
	 * @param {string} id : Item ID
	 */
	getTonality(id:string) {
		return this.db.object('/tonalities/'+id) as FirebaseObjectObservable<Tonality>;
	}

	/**
	 * Add new Tonality
	 * @param {Tonality} tonality
	 */
	addTonality(tonality) {
		return this.tonalities.push(tonality);
	}

	/**
	 * Update Tonality Data
	 * @param {string} id   : Item ID
	 * @param {object} data : Updated data
	 */
	updateTonality(id:string, data:Tonality) {
		var tonality = this.getTonality(id);
		data.updated_at = (new Date()).getTime();
		return tonality.update(data);
	}

	/**
	 * Delete Tonality
	 * @param {string} id : Item ID
	 */
	deleteTonality(id:string) {
		var promise = new Promise<any>((resolve, reject) => {
			if(!id){
				reject('ID must provided.');
			}
			else
			{
				var result = this.tonalities.remove(id).then(data => {
					this.triggerDataChange();
					resolve(data);
				})
			}
		})
		return promise;
	}
}

export class Tonality {
	$key?:string;
	name?:string = '';

	created_at?:number;
	updated_at?:number;

	constructor()
	{
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/tonality.service.ts